import styled from "styled-components";
import { colors } from "../../../../../../consts";
import { Paragraph2 } from "../../../../../../components";

export const Title = styled(Paragraph2)`
  font-size: 12px;
  line-height: 18px;
  color: ${colors.RAISIN_70};

  text-transform: uppercase;
`;
